module.exports = __webpack_public_path__ + "static/media/2lashfiler.2fa02966.png";